import { useEffect, useState } from "react";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Box, Button, TextField, Typography, Card, CardHeader, CardContent, CircularProgress } from "@mui/material";
import { Stocks } from './StockComponents';
import StoreService from '../../services/stores';
import VariantsManager from './VariantsManager';

const formSchema = Yup.object().shape({
  description: Yup.string().required(),
  quantity_in_stock: Yup.number().required("Campo Requerido"),
  prices: Yup.object().shape({
    list_price: Yup.number().required('Campo Requerido').moreThan(0),
    sale_price: Yup.number().required('Campo Requerido').moreThan(0),
  }),
  stock_new: Yup.array().of(
    Yup.object({
      prices_new: Yup.object().shape({
        list_price: Yup.number().required('Campo Requerido').moreThan(0),
        sale_price: Yup.number().required('Campo Requerido').moreThan(0),
      }),
      quantity: Yup.number().required("Campo Requerido").moreThan(0),
      store_id: Yup.string().required("Campo Requerido"),
      store: Yup.object()
    })
  ).min(1, 'Debe tener al menos un elemento en el array')
})

const FormStock = ({ article, store, onClose, onSubmit, saving = false }) => {
  const [stores, setStores] = useState(null);
  const [loading, setLoading] = useState(false);
  const [stocks] = useState([{
    prices_new: {
      list_price: article?.prices?.list_price,
      sale_price: article?.prices?.sale_price
    },
    quantity: 0,
    store_id: store?._id,
    store: store,
    description: article.article.description
  }]);

  let initialValues = {
    quantity_in_stock: article.quantity,
    prices: {
      list_price: article?.prices?.list_price,
      sale_price: article?.prices?.sale_price
    },
    stock_new: stocks,
    description: article.article.description,
    type_detail: article.type_detail || []
  }

  const loadStores = async () => {
    var resp = await StoreService.getAll();
    setStores(resp);
  }

  const handleSubmitForm = async (data) => {
    console.log(data)
    console.log("Submit")

    if (onSubmit) {
      onSubmit(data)
    }
    // const contenido = refAImprimir.current.innerHTML;
    // PrintService.print(contenido)
  }

  useEffect(() => {
    if (!stores) {
      setLoading(true)
      loadStores();
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { handleChange, handleSubmit, setFieldValue, values, errors, isValid, setValues } = useFormik({
    initialValues,
    onSubmit: handleSubmitForm,
    validationSchema: formSchema,
  })

  const { quantity_in_stock, prices, stock_new, description } = values

  // const buildEtiquetas = () => {
  //   var etiquetas = []
  //   for (let index = 0; index < stock_new[0].quantity; index++) {
  //     etiquetas.push(<Etiqueta
  //       key={index}
  //       producto={article?.article.name}
  //       precio={article?.prices?.sale_price}
  //     />)
  //   }
  //   return etiquetas;
  // }

  return <>
    <Box
      component="form"
      onSubmit={handleSubmit}
      padding={3}
    >
      <Card elevation={6}>
        <CardHeader title={article.article.name} subheader={
          <TextField
            id="description"
            label="Descripción"
            type="text"
            variant="outlined"
            fullWidth
            error={errors.description}
            helperText={errors.description}
            value={description}
            onChange={handleChange}
            multiline
            maxRows={5}
            sx={{ marginY: 1 }}
          />}
        />
        <CardContent>
          <Box display='flex' flexDirection='row' justifyContent='space-between' gap={2} marginY={1}>
            <Box display='flex' flexDirection='column' justifyContent='space-between' width='50%'>
              <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                <Typography variant="body2" color="text.secondary">
                  P. Lista:
                </Typography>
                <Typography Typography variant="h6" color="text.secondary">
                  <span>${prices.list_price}</span>
                </Typography>
              </Box>
              <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                <Typography variant="body2" color="text.secondary">
                  P. Venta:
                </Typography>
                <Typography Typography variant="h6" color="text.secondary">
                  <span>${prices.sale_price}</span>
                </Typography>
              </Box>
            </Box>
            <Box display='flex' flexDirection='row' sx={{ width: '50%' }} justifyContent='space-between' alignItems='center'>
              <Typography variant="body2" color="text.secondary">
                Stock actual:
              </Typography>
              <Typography variant="h6" color="text.secondary">
                <span>{quantity_in_stock}</span>
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
      {loading || saving ? <Box display='flex' justifyContent='center' paddingTop={3}>
        <CircularProgress color="secondary" />
      </Box> : <Stocks
        errors={errors}
        stocks={stock_new}
        stores={stores}
        prices={prices}
        onChangeField={(field, newValue) => {
          setFieldValue(field, newValue);
        }}
        onAddNew={() => {
          var s = {
            prices_new: {
              list_price: 0,
              sale_price: 0
            },
            quantity: 0,
            store_id: "",
          };
          stock_new.push(s)
          setValues({
            quantity_in_stock: article.quantity,
            prices: prices,
            stock_new: stock_new
          })
        }}
        onRemoveNew={() => {
          stock_new.pop()
          setValues({
            quantity_in_stock: article.quantity,
            prices: prices,
            stock_new: stock_new
          })
        }}
      />}
      
      {/* Gestión de Variantes */}
      {!loading && !saving && (
        <Box sx={{ mt: 3 }}>
          <VariantsManager
            variants={values.type_detail || []}
            onChange={(newVariants) => setFieldValue('type_detail', newVariants)}
            maxQuantity={stock_new.reduce((sum, s) => sum + (s.quantity || 0), 0)}
          />
        </Box>
      )}

      <Box sx={{ mt: 5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Button
          type="submit"
          variant="outlined"
          onClick={onClose}
          disabled={saving}
        >Cancelar</Button>
        <Button
          type="submit"
          variant="outlined"
          disabled={!isValid || saving}
        >Guardar</Button>
      </Box>
    </Box>
  </>
}

export default FormStock;